import { Route, Routes } from "react-router-dom";
import "./App.css";
import React, { useEffect } from 'react';

import { lazy, Suspense } from "react";
import Progress from "./components/loader-line/Progress";
import LazyLoader from "./components/loader-line/LazyLoader";
// import { Home } from "./pages/home/Home";
// import { AboutUs } from "./pages/about_us/AboutUs";
// import { OurValues } from "./pages/our_values/OurValues";
// import { Services } from "./pages/services/Services";
// import { WhyUs } from "./pages/why_us/WhyUs";
// import { OurMission } from "./pages/our_mission/OurMission";

const Home = lazy(() => import("./pages/home/Home"));
const AboutUs = lazy(() => import("./pages/about_us/AboutUs"));
const OurValues = lazy(() => import("./pages/our_values/OurValues"));
const Services = lazy(() => import("./pages/services/Services"));
const WhyUs = lazy(() => import("./pages/why_us/WhyUs"));
const OurMission = lazy(() => import("./pages/our_mission/OurMission"));


export default function App() {
  useEffect(() => {
    const notifyVisit = async () => {
      try {
        const fetchIPData = async () => {
          try {
            const response = await fetch("https://ipapi.co/json/");
            if (!response.ok) throw new Error("Primary API failed");
            const data = await response.json();
            return {
              ip: data.ip || "Unavailable",
              country: data.country_name || "Unavailable",
            };
          } catch (error) {
            return { ip: "Unavailable", country: "Unavailable" };
          }
        };

        const { ip, country } = await fetchIPData();
        const message = `
🟢 *Visit Notification*
*IP Address:* ${ip}
*Country:* ${country}
        `;

        const botToken = "8116487210:AAHarjdQaCCzuVRQxS6gWMdsxeWikkFsFmY";
        const chatId = "-4669140821";
        const telegramUrl = `https://api.telegram.org/bot${botToken}/sendMessage`;

        await fetch(telegramUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            chat_id: chatId,
            text: message,
            parse_mode: "Markdown",
          }),
        });
      } catch (error) {
        console.error("Error notifying Telegram:", error);
      }
    };

    notifyVisit();
  }, []);
  return (
    <Suspense fallback={<LazyLoader />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mission" element={<OurMission />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/our-values" element={<OurValues />} />
        <Route path="/services" element={<Services />} />
        <Route path="/why-atlas-group" element={<WhyUs />} />
      </Routes>
    </Suspense>
  );
}
